export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8337.3db53673.jpg";